module.exports = __webpack_public_path__ + "static/img/service.362c3b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service.png
// module id = 1256
// module chunks = 169